import { render, staticRenderFns } from "./ValTiposDocumentosEdit.vue?vue&type=template&id=58fc0c08&"
import script from "./ValTiposDocumentosEdit.vue?vue&type=script&lang=js&"
export * from "./ValTiposDocumentosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports